import { render, staticRenderFns } from "./reorderCategory.vue?vue&type=template&id=94805b3a&"
import script from "./reorderCategory.vue?vue&type=script&lang=js&"
export * from "./reorderCategory.vue?vue&type=script&lang=js&"
import style0 from "./reorderCategory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports